import { generate32BitUuid } from './identity';

export interface SessionOptions {
  /** @deprecated Session 以单次应用启动为边界，不再按空闲时间自动更新。 */
  sessionTimeoutMs?: number;
}

/**
 * 会话状态机：一个 SDK/应用启动周期对应一个 32 位 Session。
 */
export class SessionManager {
  private sessionId: string;

  constructor(_options?: SessionOptions) {
    this.sessionId = this.createSessionId();
  }

  private createSessionId(): string {
    return generate32BitUuid();
  }

  public getSessionId(): string {
    return this.sessionId;
  }

  public renewSession(): string {
    this.sessionId = this.createSessionId();
    return this.sessionId;
  }
}
